import { PageComponentaContext } from "widgets/interfaces"
import { injectPageComponentaContext } from "widgets/commonComponents/base/injectPageComponentaContext"
import * as classNames from "classnames"
import { getImgAlt, getImgTitle, getNewlinkTargetProperties, isAriaHidden } from "widgets/widgetsUtils"
import { secondsToMinutes } from "../../../../siteWidgets/siteWidgetUtils";
import * as apiUrls from "config/apiUrls"
import { DateDisplay } from "../../../../commonComponents/inline/dateDisplay/dateDisplay";
import { HyperLinkBuilder } from "../../../../commonComponents/inline/hyperLink";
import { IFieldDisplayData } from "../../../../commonDataObjects/interfaces";
import { PodcastPlayer } from "../../../radioWidgets/floatingPlayer/podcastPlayerButton";
import { isWcmEditor } from "../../../../../config/serverConfig";
import { videoSourceOption } from "../../../topStory/windows/contentWindow/videoLiveSourceSelector";
import { FloatingVideo } from "./floatingVideoPlayer";






interface MultiAudioAutoBepoItemSlotProps {
    item: any
    isMobileWeb?: boolean
    fieldsDisplaySettings: IFieldDisplayData
    isAudioPlaeyrEnabled?: boolean
    hideVideoAds?: boolean
    shouldAudioAutoplay?: boolean
}

@injectPageComponentaContext()
export class MultiAudioAutoBepoItemSlot extends React.Component<MultiAudioAutoBepoItemSlotProps & Partial<PageComponentaContext>, {}> {

    
    render() {
        const { item, fieldsDisplaySettings, isMobileWeb, isAudioPlaeyrEnabled, hideVideoAds, shouldAudioAutoplay } = this.props;
        if (!item) return null;
        else {
            const { title,  promotionImageDetails, publishedLink, category, articleId, hasVideo } = item;
            const audioArticleData = item.specialData && item.specialData.audioData;
            const itemLabel = `${category.textToShow} - ${title}`;
            const browserDisplayMediaMetaData = { title: title, artist: "ynet", album: category.textToShow };
            const partialArticleData = { articleId }
            const videoSrc: videoSourceOption = item.video && item.video[0] ? { src: item.video[0].main_link ? item.video[0].main_link : "", label: "", lowResSrc: item.video[0].low_res_link ? item.video[0].low_res_link : "" } : null;
          const videoPoster = item.video && item.video[0] && item.video[0].posterSrc ? item.video[0].posterSrc : "";
            const player = hasVideo ? <FloatingVideo       
                videoSource={videoSrc}
                videoTitle={title}
                isMobileWeb={isMobileWeb}
                hideVideoAds={hideVideoAds}
                poster={videoPoster}
                shouldAudioAutoplay={shouldAudioAutoplay}
            /> : <PodcastPlayer
            audioUrl={audioArticleData.audioUrl}
            title={itemLabel}
            className="audio-play-button"
            durationSeconds={audioArticleData.durationSeconds}
            browserDisplayMediaMetaData={browserDisplayMediaMetaData}
            isMobileWeb={ isMobileWeb }
            articleLink={publishedLink}
            articleData={partialArticleData}
            shouldAudioAutoplay={shouldAudioAutoplay}
                />
            return (
                <HyperLinkBuilder href={isAudioPlaeyrEnabled ? undefined : publishedLink} linkTarget={getNewlinkTargetProperties()} className={classNames("slotView", { "firstItem": isAudioPlaeyrEnabled })}>

                    <div className="mediaArea">
                        <img src={apiUrls.getImageUrl(promotionImageDetails, { w: 160, h: 90 })} alt={getImgAlt(promotionImageDetails)} title={getImgTitle(promotionImageDetails)} aria-hidden={isAriaHidden(promotionImageDetails)} />
                        {isAudioPlaeyrEnabled && <div className={"bepoAudioIcon"} style={{ display: audioArticleData ? "block" : "none" }} src={"/Common/images/bepo/play_btn_bepo_new.svg"} />}

                    </div>

                    <div className="textArea">
                        {fieldsDisplaySettings.isTitleVisible &&
                            <div className="slotTitle">
                                {title}
                            </div>}
                        <div className="moreDetails">
                            <div className="duration">{audioArticleData && audioArticleData.durationSeconds && secondsToMinutes(audioArticleData.durationSeconds, "דק'")}</div>
                            {fieldsDisplaySettings.isDateVisible && <DateDisplay date={item.dateUpdatedOnSite} isHiddenHourInYesterday={true} />}
                        </div>

                    </div>
                    {isAudioPlaeyrEnabled && !isWcmEditor() && player }
                    {isAudioPlaeyrEnabled && <div className="new-item-sign">
                        <video className="player-sign" src={"https://www.ynet.co.il/Common/images/bepo/wave-radio.webm"} autoPlay loop muted playsInline />
                        <span>הכי חדש</span>
                    </div>}
                </HyperLinkBuilder>
            )
        }

    }
}